import { createFileRoute } from '@tanstack/react-router'
import { ProjectStatusReportsPage } from '../../../../../features/projects/status-reports/project-reports-page'
import { projectReportsSearchSchema } from '../../../../../features/projects/status-reports/search'

/** A project's weekly status reports, newest first (P7); projects.read comes from the workspace route. */
export const Route = createFileRoute('/_app/projects/$projectId/reports/')({
  staticData: { crumb: 'projectReports' },
  validateSearch: projectReportsSearchSchema,
  component: ProjectStatusReportsPage,
})
